console.log("js/reservation.js -> v0.1.0");
function receipt_field(title, price) {
	return (
		'<div class="receipt_field_wrapper"><div class="receipt_field_name">' +
		title +
		'</div><div class="receipt_field_price">' +
		price +
		"</div></div>"
	);
}

function formatCurrency(x) {
	if (x && x.toString) {
		return selectedCurrencyFormat.replace(
			"{amount}",
			x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
		);
	} else {
		return selectedCurrencyFormat.replace("{amount}", undefined);
	}
}

function receipt_update() {
	if ($("#receipt_with_fees").length) {
		var checked = $(".package-selection-item:checked").parent().parent();

		if ($(checked).find('[data-id="0"]').length) {
			$("#receipt_with_fees").hide();
		} else {
			$("#receipt_with_fees").show();
		}
		var price = $(checked).find(".price").attr("data-price");
		$("#receipt_pack").html(
			receipt_field(
				$(checked)
					.find(".package-attribute:nth-of-type(1)")
					.text()
					.trim() +
					"</br>" +
					$(checked)
						.find(".package-attribute:nth-of-type(2)")
						.text()
						.trim(),
				formatCurrency(price)
			)
		);
		$("#receipt_with_fees #receipt_final .receipt_field_price").text(
			formatCurrency(Math.round(price) + Math.round(price * 0))
		);
	}
}

(() => {
	if ($("#receipt_with_fees").length) {
		receipt_update();
	}

	// reservation button loading state
	const reservationSubmitButton = document.querySelector(
		".reservation-submit"
	);

	if (reservationSubmitButton) {
		document.addEventListener("click", function (event) {
			if (event.target.classList.contains("reservation-submit")) {
				event.preventDefault();
				reservationSubmitButton.classList.add("is-loading");
				reservationSubmitButton.disabled = true;
				// ensure inline loader is visible
				const btnLoader = reservationSubmitButton.querySelector('.loader');
				if (btnLoader) {
					btnLoader.style.display = 'flex';
				}
				
				const organizerSlugEl =
					document.getElementById("organizer_slug");
				const listingSlugEl = document.getElementById("listing_slug");
				const arrivalEl = document.getElementsByName("arrival_date")[0];
				const packageEl = document.getElementById("package_id");
				const form = document.querySelector("#reservation-form");

				let url;

				if (
					organizerSlugEl &&
					organizerSlugEl.value &&
					listingSlugEl &&
					listingSlugEl.value &&
					arrivalEl &&
					arrivalEl.value &&
					packageEl &&
					packageEl.value
				) {
					const organizerSlug = organizerSlugEl.value;
					const listingSlug = listingSlugEl.value;
					const arrivalDate = encodeURIComponent(arrivalEl.value);
					const packageId = encodeURIComponent(packageEl.value);

					url = `/${organizerSlug}/${listingSlug}/reservation?arrival_date=${arrivalDate}&package_id=${packageId}`;
				} else {
					url = window.location.pathname + window.location.search;
				}

				const formData = new FormData(form);
				const params = {
					body: formData,
					method: "POST",
				};

				// check if the form contains any errors, otherwise submit the form
				if (validation.hasFormErrors("#reservation-form")) {
					reservationSubmitButton.classList.remove("is-loading");
					reservationSubmitButton.disabled = false;
					const btnLoader = reservationSubmitButton.querySelector('.loader');
					if (btnLoader) {
						btnLoader.style.display = 'none';
					}
					return false;
				}

				fetch(url, params)
				.then(response => {
					if (response.status === 200) {
						return response.json();
					} else {
						throw new Error('Network response was not ok');
					}
				})
				.then(data => {
					if (data && data['redirect']) {
						window.location.href = data['redirect'];
					}
				})
				.catch(error => {
					console.error('Error:', error);
				})
			}
		});
	}

	document.addEventListener("focusout", function (event) {
		if (
			event.target.matches(
				"#reservation-form .simple-validation .form-control"
			)
		) {
			validation.simpleValidation(event.target, ".simple-validation");
		}
		if (
			event.target.matches(
				"#reservation-form .email-validation .form-control"
			)
		) {
			validation.emailValidation(event.target, ".email-validation");
		}
	});
})();
